import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import RcSlider from 'rc-slider';
import useIsMount from '../../hooks/use-mount';

export default function Slider(props) {
  const {onChange, className, value, step, disabled, min, max, name, marks, ...rest} = props;
  const [sliderValue, setSliderValue] = React.useState(value || 0);
  const minLimit = min < 0 ? Slider.defaultProps.min : min;
  const maxLimit = max < 0 ? Slider.defaultProps.max : max;
  const isMount = useIsMount();

  if (min < 0 || max < 0) {
    console.warn(
      `Slider: Negative values for 'min' and 'max' are not supported. Defaulting to ${Slider.defaultProps.min} and ${Slider.defaultProps.max}.`,
    );
  }

  React.useEffect(() => {
    setSliderValue(value);
  }, [value]);

  React.useEffect(() => {
    if (!isMount) {
      setSliderValue(sliderValue);
      onChange(sliderValue);
    }
  }, [sliderValue]);

  const handleSliderChange = React.useCallback(changedValue => {
    const val = changedValue;
    setSliderValue(val);
  });

  return (
    <RcSlider
      className={classnames(className)}
      name={name}
      min={minLimit}
      max={maxLimit}
      marks={marks}
      value={sliderValue}
      step={step}
      onChange={handleSliderChange}
      disabled={disabled}
      {...rest}
    />
  );
}

Slider.defaultProps = {
  disabled: false,
  min: 0,
  max: 99,
  step: 1,
  marks: {},
};

Slider.propTypes = {
  /** A callback to execute when input changes. Will be passed the input value */
  onChange: PropTypes.func,
  /** An optional className to add to the HTML element. */
  className: PropTypes.string,
  /** Value of the slider */
  value: PropTypes.number,
  /** Name of the slider */
  name: PropTypes.string,
  /** Minimum limit of the slider */
  min: PropTypes.number,
  /** Maximum limit of the slider */
  max: PropTypes.number,
  /** Legends of the slider independent of step */
  marks: PropTypes.object,
  /** step of the slider */
  step: PropTypes.number,
  /** A boolean when passed disables the slider */
  disabled: PropTypes.bool,
};
